<template>
  <div>
    <TextArea
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      :value="value"
      hide-details
      :rules="rules"
    ></TextArea>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
    settings: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Array,
      default: function () {
        return [];
      },
    },
    links: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    placeholder() {
      return this.settings.placeholder || this.label;
    },
  },
};
</script>

<style scoped lang="scss"></style>
